export enum Environment {
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'production',
}

export const environments = [
  Environment.DEV,
  Environment.STAGING,
  Environment.PROD,
];
